import secureLog from './secureLogger';

/**
 * Handles API responses securely by sanitizing sensitive data
 * before adding to the store or logging
 */
export const handleApiResponse = (response, sanitizeConfig = {}) => {
  // Log sanitized version for debugging
  secureLog.debug('API Response received', response);
  
  // Return the full response for processing
  return response;
};

/**
 * Sanitizes listing data for client-side storage
 */
export const sanitizeListingData = (listing) => {
  if (!listing) return null;
  
  // Create a deep copy
  const sanitized = JSON.parse(JSON.stringify(listing));
  
  // Remove sensitive fields from relationships
  if (sanitized.relationships) {
    // Keep only necessary relationship data
    if (sanitized.relationships.author?.data?.id) {
      sanitized.relationships.author.data = {
        id: sanitized.relationships.author.data.id,
        type: sanitized.relationships.author.data.type
      };
    }
  }
  
  return sanitized;
};

/**
 * Sanitizes user data for client-side storage
 */
export const sanitizeUserData = (user) => {
  if (!user) return null;
  
  // Create a deep copy
  const sanitized = JSON.parse(JSON.stringify(user));
  
  // Remove sensitive fields
  if (sanitized.attributes) {
    // Keep only necessary user attributes
    const safeAttributes = ['profile', 'state'];
    Object.keys(sanitized.attributes).forEach(key => {
      if (!safeAttributes.includes(key)) {
        delete sanitized.attributes[key];
      }
    });
  }
  
  return sanitized;
};

/**
 * Sanitizes transaction data for client-side storage
 */
export const sanitizeTransactionData = (transaction) => {
  if (!transaction) return null;
  
  // Create a deep copy
  const sanitized = JSON.parse(JSON.stringify(transaction));
  
  // Keep only necessary transaction data
  if (sanitized.attributes?.protectedData) {
    sanitized.attributes.protectedData = {
      // Only keep specific fields that are needed
      unitType: sanitized.attributes.protectedData.unitType
    };
  }
  
  return sanitized;
};

export default {
  handleApiResponse,
  sanitizeListingData,
  sanitizeUserData,
  sanitizeTransactionData
}; 